const state = {
  currentAddress: null,
  invoice: {
    setting: {
      needInvoice: false,
      customerInvoiceId: null,
      useDependenceInvoiceAddress: false,
    },
    currentInvoiceAddress: { id: null, name: null },
  },
};
const mutations = {
  CHANGE_DELIVER_ADDRESS(state, data) {
    state.currentAddress = data;
  },
  CHANGE_INVOICE_ADDRESS(state, data) {
    state.invoice.currentInvoiceAddress = data;
  },
  CHANGE_INVOICE_SETTING(state, data) {
    state.invoice.setting = data;
  },
};
const actions = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
